"use client"
import { TTabsProps } from "@/app/types/types"
import { useEffect } from "react"
import SingleTab from "./SingleTab"

export default function Tabs({
  data,
  activeTab,
  setActiveTab,
  setActiveCard,
  customClass,
  CustomTabsStyle,
  navRefs
}: TTabsProps) {
  const handleTabChange = (value?: string | number) => {
   if(value){
    setActiveTab(value)
   }   
  }

  useEffect(() => {
    if (!data) return
    if (!activeTab && setActiveTab) setActiveTab(data?.[0]?.value)
  }, [data, activeTab, setActiveTab])

  return (
      <div className={`tabs_wrapper `}>
        <div className={`tabs flex py-5 gap-3  ${customClass} ${CustomTabsStyle}`}>
          {data.map((tab, index) => (
            <SingleTab
              data={tab}
              active={activeTab == tab?.value}
              onClick={() => {
                handleTabChange(tab?.value)
                if(setActiveCard) setActiveCard(null)
              }}
              ref={navRefs ? navRefs[index] : null}
              key={`tabs-item-${tab?.value}-${index}`}
            />
          ))}
        </div>
      </div>
  )
}
